export default {
  Label_Common: {
    Dai_ChuShiHua: '待初始化',
    ZhengZai_ChuShiHua: '正在初始化',
    YiChang: '異常',
    ZhengChang_YingYe: '正常營業',
    TingZhi_YingYe: '停止營業',
  },
}
